import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { Badge, UncontrolledTooltip } from 'reactstrap';

import { getSetting } from '../helpers/Settings';
import { getUserTimeZone } from '../helpers/DateTime';

const TrashRemainingDays = ({ delay, file, collection }) => {
  const intl = useIntl();

  if (!file && !collection) return null;

  const element = file || collection;

  if (!element.deleted_at) return null;

  const limit = getSetting('trash_days');
  const now = moment().tz(getUserTimeZone());
  const daysLeft = moment(element.deleted_at, 'YYYY-MM-DD HH:mm:ss').add(limit, 'days').diff(now, 'days') + 1;

  return (
    <>
      <Badge
        color="secondary"
        className="trash-remaining-days-badge ml-1"
        id={`TrashRemainingDaysBadge-${element.uuid}`}
      >
        <i className="far fa-trash mr-1" />
        <span>{daysLeft}</span>
      </Badge>
      <UncontrolledTooltip
        target={`TrashRemainingDaysBadge-${element.uuid}`}
        className="collection-description-tooltip"
        fade={false}
        placement="bottom"
        {...(delay ? { delay: { show: 210, hide: 210 } } : {})}
      >
        {intl.formatMessage({ defaultMessage: 'Days remaining in trash' })}
      </UncontrolledTooltip>
    </>
  );
};

TrashRemainingDays.propTypes = {
  delay: PropTypes.bool,
  file: PropTypes.object,
  collection: PropTypes.object,
};

TrashRemainingDays.defaultProps = {
  delay: false,
  file: null,
  collection: null,
};

export default TrashRemainingDays;
